import moment, { Moment } from "moment";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ActionAbsencesEnum } from "../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { CommandeChangementEtatAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeChangementEtatAbsenceDto";
import { CongeDto } from "../../dto/GenApi.iNotPaie.Dto/CongeDto";
import { CongesSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/CongesSalarieDto";
import { EtatAbsencesEnum } from "../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { JourDuMois } from "../../dto/GenApi.iNotPaie.Dto/JourDuMois";
import { JourFerieDto } from "../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { Salariee } from "../../dto/GenApi.iNotPaie.Dto/Salariee";
import { TypeRegroupementEquipe } from "../../dto/GenApi.iNotPaie.Dto/TypeRegroupementEquipe";
import DataTestIDHelper from "../../Helper/DataTestID/DataTestIDHelper";
import Scroll from "../../shared/components/Scroll/Scroll";
import { TypeCalendrier } from "../../shared/models/typeCalendrier";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import {
    BackgroundStyle,
    DayObject,
    ExpandModel,
    JoursFerieModel,
    KeyValue,
    Position,
    TooltipInfo,
    TypeCongeObject
} from "./calendrier.model";

@Component({
    components: {
        DatePickerModal: require("./datePickerModal/datePickerModal.vue.html"),
        ModalAttestationCrpcenTpt: require("./modalAttestationCrpcenTpt/modalAttestationCrpcenTpt.vue.html")
    }
})
export default class CalendrierComponent extends Vue {
    @Prop()
    public typeCalendrier!: TypeCalendrier;

    public sortDisplaySelected = TypeRegroupementEquipe.alphabetique;

    public monthNames: string[] = ParametresInstance.listeMois;
    public dayNames: string[] = ParametresInstance.listeJoursMini;
    public currentMonth: number = new Date().getUTCMonth();
    public currentYear: number = new Date().getUTCFullYear();
    public currentDate: Date = new Date();

    public filterTypeConges = "";
    public filterName = "";
    public lastSend = 0;
    public idSalarie?: number = 0;
    public idNotaire?: number = 0;

    public alreadyInit = false;
    public getData: CongesSalarieDto = this.getDefaultData();
    public listTypeAbsence: ExpandModel[] = [];
    public listDays: JoursFerieModel[] = [];
    public listDaysTemp: DayObject[] = [];
    public listJourFerie: JourFerieDto[] = [];
    public listLegend: TypeCongeObject[] = [];
    public listLegendTemp: TypeCongeObject[] = [];
    public listeClassifications: ParametreDto[] = [];

    public tooltipVisible = false;
    public enableLegend = false;
    public enableAction = false;
    public enableExport = false;
    public enableSearch = false;
    public enableCollective = false;
    public enableFilter = false;
    public firstSetLegend = true;
    public firstSetGroup = false;
    public enableNavigation = false;
    public dataReady = false;
    public dataChange = false;
    public haveConge = false;
    public problemeChargement = false;
    public idTriggerChangementMois: number = 0;

    public valueSyncHorizontal = 0;
    public valueSyncVertical = 0;
    public valueSyncIsSmooth = false;
    public listeCodesAbsencesCrpcen = ["JCMAT", "JCPAT", "JMALA", "JMALS", "JCSNA"];
    public listeCodesAbsencesCrpcenTpt = ["TPTH", "TPTHP"];

    public canEditEvenIfCalcule = false;

    public modalAttestationCrpcenTptVisible: boolean = false;
    public idCongeCrpcenTpt: number = 0;

    public tooltipInfo: TooltipInfo = {
        idSalarie: 0,
        idContrat: 0,
        idConge: 0,
        congeCode: "",
        etat: EtatAbsencesEnum.EnAttenteAnnulationGestionnaire
    };

    public tooltipPosition: Position = {
        x: 0,
        y: 0
    };

    public listSortDisplay: KeyValue[] = [];

    public mounted(): void {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.init();
        });

        EventBus.$on(EventConstants.RELOAD_ACCUEIL, () => {
            this.init();
        });

        this.init();
    }

    public init(filterExternal = ""): void {
        this.filterName = (filterExternal === "") ? "" : filterExternal;

        // Get Utilisateur
        if (ParametresInstance.utilisateurCourant != undefined) {
            this.idSalarie = ParametresInstance.utilisateurCourant.IdSalarie;
            this.idNotaire = ParametresInstance.utilisateurCourant.IdNotaire;
        }

        // Get Periode
        if (ParametresInstance.societeCourante != undefined &&
            ParametresInstance.societeCourante.PeriodeActive != undefined) {
            this.currentDate = moment.utc(ParametresInstance.societeCourante.PeriodeActive).toDate();
        } else {
            this.currentDate = new Date();
        }

        this.currentMonth = this.currentDate.getUTCMonth();
        this.currentYear = this.currentDate.getUTCFullYear();

        ServicesFactoryInstance.ParametresService.getParametrageCalendrier(data => {
            this.listeClassifications = data.ListeClassification;
            this.listJourFerie = data.ListeJoursFeries;

            this.fetchData();
        });

        this.checkUtilisateurAndSocieteCourants();
        this.canEditEvenIfCalcule = ParametresInstance.userIsAuthorized([RoleConstants.AdministrateurPST, RoleConstants.Payeur, RoleConstants.Administrateur]);
    }

    public changeType(typeCalendrier: TypeCalendrier): void {
        this.typeCalendrier = typeCalendrier;
        this.fetchData();
    }

    public fetchData(): void {
        this.dataReady = false;
        this.initListSortDisplay();
        this.getData = this.getDefaultData();

        switch (this.typeCalendrier) {
            case TypeCalendrier.Accueil:
                this.enableLegend = true;
                this.enableExport = true;
                this.enableSearch = true;
                this.enableAction = false;
                this.enableCollective = false;
                this.enableNavigation = true;
                this.enableFilter = true;

                if (!this.firstSetGroup) {
                    this.sortDisplaySelected = TypeRegroupementEquipe.alphabetique;
                }

                ServicesFactoryInstance.AbsencesService.GetCongeAdministrateur(this.currentYear, this.currentMonth + 1, data => {
                    this.initData(data);
                    this.dataReady = true;
                }, () => {
                    this.dataReady = true;
                });

                break;

            case TypeCalendrier.GestionDesAbsences:
                this.enableLegend = true;
                this.enableExport = true;
                this.enableSearch = true;
                this.enableAction = true;
                this.enableCollective = true;
                this.enableNavigation = true;
                this.enableFilter = true;

                if (!this.firstSetGroup) {
                    this.sortDisplaySelected = TypeRegroupementEquipe.alphabetique;
                }

                ServicesFactoryInstance.AbsencesService.GetCongeAdministrateur(this.currentYear, this.currentMonth + 1, data => {
                    this.initData(data);
                    this.dataReady = true;
                }, () => {
                    this.dataReady = true;
                });

                break;

            case TypeCalendrier.EspaceSalarie:
                this.enableLegend = false;
                this.enableExport = true;
                this.enableSearch = true;
                this.enableAction = false;
                this.enableCollective = false;
                this.enableNavigation = false;
                this.enableFilter = false;

                if (!this.firstSetGroup) {
                    this.sortDisplaySelected = TypeRegroupementEquipe.alphabetique;
                }

                ServicesFactoryInstance.AbsencesService.GetCongeSalarie(this.currentYear, this.currentMonth + 1, this.idSalarie!, data => {
                    this.initData(data);
                    this.dataReady = true;
                }, () => {
                    this.dataReady = true;
                });

                break;

            case TypeCalendrier.EspaceValideurSalarie:
            case TypeCalendrier.EspaceValideurExterne:
                this.enableLegend = true;
                this.enableExport = true;
                this.enableSearch = true;
                this.enableAction = false;
                this.enableCollective = false;
                this.enableNavigation = false;
                this.enableFilter = true;

                if (!this.firstSetGroup) {
                    this.sortDisplaySelected = TypeRegroupementEquipe.alphabetique;
                }
                const idUtilisateurConnecte = this.idSalarie ?? this.idNotaire;
                ServicesFactoryInstance.AbsencesService.GetAbsenceUtilisateurValideurConges(this.currentYear, this.currentMonth + 1, idUtilisateurConnecte!, data => {
                    this.initData(data);
                    this.dataReady = true;
                }, () => {
                    this.dataReady = true;
                });

                break;
        }
    }

    private checkUtilisateurAndSocieteCourants() {
        if (ParametresInstance.utilisateurCourant === undefined || ParametresInstance.societeCourante === undefined) {
            this.problemeChargement = true;
        } else {
            this.problemeChargement = false;
        }
    }

    private initData(data: CongesSalarieDto): void {
        this.setListDay();
        this.getData = data;
        this.orderData("", this.filterName);
    }

    public filterData(): void {
        this.orderData(this.filterTypeConges, this.filterName);
    }

    private orderData(filterType: string, filterName: string): void {
        switch (this.sortDisplaySelected) {
            case TypeRegroupementEquipe.service:
                this.setOrderCategorieService(true, filterType, filterName);
                break;
            case TypeRegroupementEquipe.responsable:
                this.setOrderCategorieService(false, filterType, filterName);
                break;
            default: // Alphabétique
                this.setOrderAlphabetique(filterType, filterName);
                break;
        }

        this.setLegend();
        this.closeTooltip();
        this.setSizeScrollbar();
        this.dataReady = true;
        this.dataChange = false;
    }

    private setOrderAlphabetique(filterType: string, filterName: string): void {
        this.listTypeAbsence = [];
        let listTemp = this.getData.Salariees;

        // FILTER
        if (filterType !== "") {
            listTemp = this.getFilterTypeData(listTemp, filterType);
        }

        if (filterName !== "") {
            listTemp = this.getFilterNameData(listTemp, filterName);
        }

        this.listTypeAbsence.push({
            Id: this.getData.Id,
            Type: this.getData.Type,
            Salariees: listTemp,
            IsCollapse: false,
            IsHover: false,
            EstAffichagePlanningAnonymise: this.getData.EstAffichagePlanningAnonymise
        });
    }

    private setOrderCategorieService(isService: boolean, filterType: string, filterName: string): void {
        this.listTypeAbsence = [];
        let listTemp = this.getData.Salariees;

        // FILTER
        if (filterType !== "") {
            listTemp = this.getFilterTypeData(listTemp, filterType);
        }

        if (filterName !== "") {
            listTemp = this.getFilterNameData(listTemp, filterName);
        }

        // GROUP
        for (const salariee of listTemp) {
            const searchType = (isService) ? salariee.LibelleService : salariee.LibelleCategorie;

            if (this.listTypeAbsence.filter(listType => listType.Type === searchType).length === 0) {
                let id = 0;

                if (!isService) {
                    if (this.listeClassifications.filter(orderType => orderType.Libelle === salariee.LibelleCategorie)[0] === undefined) {
                        // Si la classification n'est pas retrouvée, on affecte un code de tri par défaut.
                        id = 999;
                    } else {
                        id = Number(this.listeClassifications.filter(orderType => orderType.Libelle === salariee.LibelleCategorie)[0].ValeurTri);
                    }
                } else {
                    if (salariee.LibelleService === "") {
                        id = 0;
                    } else {
                        id = this.listTypeAbsence.length + 1;
                    }
                }

                this.listTypeAbsence.push({
                    Id: id,
                    Type: searchType,
                    Salariees: [salariee],
                    IsCollapse: false,
                    IsHover: false,
                    EstAffichagePlanningAnonymise: this.getData.EstAffichagePlanningAnonymise
                });
            } else {
                const list = this.listTypeAbsence.filter(listType => listType.Type === searchType)[0];
                list.Salariees.push(salariee);
            }
        }

        // ORDER
        if (!isService) {
            this.listTypeAbsence = this.listTypeAbsence.sort(this.compareCategorie);
        } else {
            this.listTypeAbsence = this.listTypeAbsence.sort(this.compareService);
        }
    }

    private compareCategorie(a: ExpandModel, b: ExpandModel): number {
        if (a.Id! < b!.Id!) {
            return -1;
        }
        if (a.Id! > b.Id!) {
            return 1;
        }

        return 0;
    }

    private compareService(a: ExpandModel, b: ExpandModel): number {
        if (a.Type! < b!.Type!) {
            return -1;
        }
        if (a.Type! > b.Type!) {
            return 1;
        }

        return 0;
    }

    private getFilterTypeData(list: Salariee[], filterType: string): Salariee[] {
        const salarieFilter: Salariee[] = [];

        for (const salariee of list) {
            for (const mois of salariee.JoursDuMois) {
                if (mois.Conges.filter(conge => conge.TypeConges.Code === filterType).length &&
                    salarieFilter.filter(getSalarie => getSalarie.Id === salariee.Id).length === 0) {
                    salarieFilter.push(salariee);
                }
            }
        }

        return salarieFilter;
    }

    private getFilterNameData(listSalarie: Salariee[], filterName: string): Salariee[] {
        return listSalarie.filter(s => filterName == "" ||
            (s.Intitule != undefined && s.Intitule.toLowerCase().indexOf(filterName.toLowerCase()) > -1));
    }

    private setLegend(): void {
        this.listLegendTemp = [];

        if (this.listTypeAbsence.length > 0) {
            for (const typeAbsence of this.listTypeAbsence) {
                for (const salarie of typeAbsence.Salariees) {
                    for (const currentMonth of salarie.JoursDuMois) {
                        if (currentMonth.Conges.length) {
                            for (const conge of currentMonth.Conges) {
                                if (this.listLegendTemp.filter(type => type.Code === conge.TypeConges.Code).length === 0) {
                                    this.listLegendTemp.push({
                                        Id: conge.TypeConges.Id,
                                        Code: conge.TypeConges.Code,
                                        Couleur: conge.TypeConges.Couleur,
                                        Libelle: conge.TypeConges.LibelleConges
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }

        if (this.firstSetLegend) {
            this.listLegend = this.listLegendTemp;
            this.firstSetLegend = false;
        }

        this.haveConge = this.listLegendTemp.length > 0;
    }

    public exporter(): void {
        NotificationServiceInstance.SendInformation("La demande d'édition a été prise en compte. Le document sera bientôt disponible");
        const currentMonth = this.currentMonth + 1;
        const listTypeAbsenceExport = this.listTypeAbsence;

        // INVERSE A/M => M/A
        listTypeAbsenceExport[0].Salariees.forEach(function (salaries: Salariee) {
            salaries.JoursDuMois.forEach(function (jours: JourDuMois) {
                if (jours.Conges.length === 2) {
                    const first = jours.Conges[0];
                    const last = jours.Conges[1];

                    if (first.IsMatin && first.IsApresMidi && first.IsFirst && !first.IsLast) {
                        jours.Conges[1] = first;
                        jours.Conges[0] = last;
                    }
                }
            });
        });

        ServicesFactoryInstance.AbsencesService.exportAbsences(listTypeAbsenceExport, (r: Blob) => {
            const libelle = "absences " + currentMonth + "_" + this.currentYear + ".xlsx";
            this.dataReady = true;

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(r, libelle);
            } else {
                const link = document.createElement("a");
                document.body.appendChild(link);

                link.href = window.URL.createObjectURL(r);
                link.download = libelle;
                link.click();

                NotificationServiceInstance.SendSuccess("L'édition s'est correctement déroulée !");
            }
        });
    }

    private isBetween(debut, fin, dateCellule: Moment): boolean {
        return dateCellule.isBetween(debut, fin, "days", "[]");
    }

    public setListDay(): void {
        this.listDays = [];
        this.listDaysTemp = this.getDaysInMonth(this.currentMonth, this.currentYear);

        const today = new Date();

        for (let i = 0; i < this.listDaysTemp.length; i++) {
            const d = moment(this.listDaysTemp[i].date);

            this.listDays.push({
                day: this.listDaysTemp[i],
                ferie: this.listJourFerie.filter(f => d.isSame(f.Date, "d"))[0],
                isToday: d.isSame(today, "d")
            });
        }
    }

    public getDaysInMonth(currentMonth: number, currentYear: number): DayObject[] {
        const date = new Date(currentYear, currentMonth, 1);
        const days: DayObject[] = [];

        while (date.getMonth() === currentMonth) {
            const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const dayObject: DayObject = {
                date: d,
                nameDay: date.getDay(),
                valueDay: date.getDate(),
                end: date.getDay() == 0 || date.getDay() == 6
            };
            days.push(dayObject);
            date.setDate(date.getDate() + 1);
        }

        return days;
    }

    public naviguateMonth(isAdd: boolean): void {
        this.isDatePickerVisible = false;
        this.closeTooltip();
        this.dataChange = true;

        if (isAdd) {
            this.currentDate.setMonth(this.currentDate.getMonth() + 1, 1);
        } else {
            this.currentDate.setMonth(this.currentDate.getMonth() - 1, 1);
        }

        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();
        this.lastSend++;

        this.setNewDate();
    }

    public switchExpand(typeConge: ExpandModel): void {
        typeConge.IsCollapse = !typeConge.IsCollapse;
        this.setSizeScrollbar();
        this.closeTooltip();
    }

    public setSizeScrollbar(): void {
        const scrollLeftCalendar = this.$refs.scrollLeftCalendar as Scroll;
        const scrollRightCalendar = this.$refs.scrollRightCalendar as Scroll;

        if (scrollLeftCalendar == undefined && scrollRightCalendar == undefined) {
            return;
        }

        setTimeout(() => {
            scrollLeftCalendar.setSizeScrollbar();
            scrollLeftCalendar.setResetScroll();
            scrollRightCalendar.setSizeScrollbar();
            scrollRightCalendar.setResetScroll();
        }, 10);
    }

    public hoverHeader(typeConge: ExpandModel): void {
        typeConge.IsHover = true;

        this.closeTooltip();
        this.$forceUpdate();
    }

    public leaveHeader(typeConge: ExpandModel): void {
        typeConge.IsHover = false;

        this.closeTooltip();
        this.$forceUpdate();
    }

    public hoverCell(conges: CongeDto[], period: string): void {
        if (!this.enableAction) {
            return;
        }

        const getConge = this.getCongeInConges(conges, period);

        for (const typeAbsence of this.listTypeAbsence) {
            for (const salarie of typeAbsence.Salariees) {
                for (const currentDay of salarie.JoursDuMois) {
                    if (currentDay.Conges.length) {
                        for (const conge of currentDay.Conges) {
                            if (conge.Id === getConge.Id) {
                                conge.IsHover = true;
                            }
                        }
                    }
                }
            }
        }
    }

    public leaveCell(): void {
        if (!this.enableAction) {
            return;
        }

        this.listTypeAbsence.filter(
            typeAbsence => typeAbsence.Salariees.filter(
                salarie => salarie.JoursDuMois.filter(
                    jour => jour.Conges.filter(
                        conge => conge.IsHover = false)
                )));
    }

    private getCongeInConges(conges: CongeDto[], period: string): CongeDto {
        if (conges.length === 1) {
            return conges[0];
        } else {
            conges = this.reOrderConges(conges);
            if (period === "M") {
                return conges[0];
            } else {
                return conges[1];
            }
        }
    }

    public getEnumAlphabetique(): number {
        return TypeRegroupementEquipe.alphabetique;
    }

    public getEnumEspaceSalarie(): number {
        return TypeCalendrier.EspaceSalarie;
    }

    public openSalarie(idSalarie: any, titre: string): void {
        if (this.enableNavigation) {
            this.closeTooltip();

            if (ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST])) {
                EventBus.NavigateTo({
                    path: "/ficheSalarie/" + idSalarie,
                    query: { titre: titre }
                });
            }
        }
    }

    public getCongeByDate(conges: CongeDto[], date: Date): CongeDto[] {
        return conges.filter(c => this.isBetween(c.Debut, c.Fin, moment(date)));
    }

    public shouldShowAnnulationOnCellRight(conges: CongeDto[], period: string): boolean {
        const conge = this.getCongeInConges(conges, period);

        if (conge.IsMatin || !conge.IsApresMidi) {
            return false;
        }

        return true;
    }

    public getClassCell(infosJour: JourDuMois): string {
        let conges = infosJour.Conges;
        const dateCellule = infosJour.Date;
        if (conges.length == 0) {
            return "";
        }

        let cellClass = "";

        // ---------------------------------------------------------
        // ------------------------------------------------------- 1
        // ---------------------------------------------------------
        if (conges.length === 1) {
            const conge = conges[0];

            // --------------------------------------------------------- ONE
            if (conge.IsFirst && conge.IsLast) {
                cellClass = "cell-one";

                // --- DEMI MATIN
                if (conge.IsMatin && !conge.IsApresMidi) {
                    cellClass += "-demi-m";
                }

                // --- DEMI APREM
                if (!conge.IsMatin && conge.IsApresMidi) {
                    cellClass += "-demi-a";
                }
            }

            // --------------------------------------------------------- MIDDLE : jour plein
            if (!conge.IsFirst && !conge.IsLast) {
                cellClass = "cell-middle";
            }

            // --------------------------------------------------------- LEFT : le début du congé
            if (conge.IsFirst && !conge.IsLast) {
                cellClass = "cell-left";

                // --- DEMI : l'après midi
                if (dateCellule == conge.Debut && conge.Fin != undefined && dateCellule < conge.Fin && conge.IsApresMidi) {
                    cellClass += "-demi";
                }
            }

            // --------------------------------------------------------- RIGHT : la fin du congé
            if (!conge.IsFirst && conge.IsLast) {
                cellClass = "cell-right";

                // --- DEMI : le matin
                if (dateCellule == conge.Fin && conge.Debut != undefined && dateCellule > conge.Debut && conge.IsMatin) {
                    cellClass += "-demi";
                }
            }
        }
        // ---------------------------------------------------------
        // ------------------------------------------------------- 2
        // ---------------------------------------------------------
        else {
            conges = this.reOrderConges(conges);
            const congeA = conges[0];
            const congeB = conges[1];

            // --------------------------------------------------------- ONE
            if (congeA.IsFirst && congeA.IsLast && congeB.IsFirst && congeB.IsLast) {
                cellClass = "cell-one";
            }

            // --------------------------------------------------------- MIDDLE : jour plein
            if (!congeA.IsFirst && congeA.IsLast && congeB.IsFirst && !congeB.IsLast) {
                cellClass = "cell-middle";
            }

            // --------------------------------------------------------- LEFT : le début du congé
            if (congeA.IsFirst && congeA.IsLast && congeB.IsFirst && !congeB.IsLast) {
                cellClass = "cell-left";
            }

            // --------------------------------------------------------- RIGHT : la fin du congé
            if (!congeA.IsFirst && congeA.IsLast && congeB.IsFirst && congeB.IsLast) {
                cellClass = "cell-right";
            }
        }

        return cellClass;
    }

    public reOrderConges(conges: CongeDto[]): CongeDto[] {
        let congeA = conges[0];
        let congeB = conges[1];

        if (moment(congeA.Fin).isAfter(congeB.Fin) ||
            (moment(congeA.Fin).isSame(congeB.Fin, "days") && congeA.IsApresMidi)) {
            congeA = conges[1];
            congeB = conges[0];
        }

        return [congeA, congeB];
    }

    public getTitle(salarie: Salariee, conges: CongeDto[], period: string): string {
        const conge: CongeDto = this.getCongeInConges(conges, period);
        let title: string = "";
        if (this.haveDetailsOnAbsence(salarie.Id, conge.TypeConges.Code)) {
            let titleValidate = "";
            if (conge.Etat == EtatAbsencesEnum.Cloture) {
                titleValidate = " (Sur bulletin)";
            } else if (conge.Etat == EtatAbsencesEnum.Calcule) {
                titleValidate = " (Sur bulletin en cours)";
            }

            title = conge.TypeConges.LibelleConges! + " du " + moment(conge.Debut).format("DD/MM/YY") + " au " + moment(conge.Fin).format("DD/MM/YY") + titleValidate;
        }

        return title;
    }

    public getClassWeekEndEtFerie(day: Date): string {
        const dayConvert = moment.utc(day).toDate();

        if (this.listJourFerie.find(j => j.Date == day)) {
            return "is-ferie ";
        }

        if (dayConvert.getUTCDay() == 0 || dayConvert.getUTCDay() == 6) {
            return "w-e";
        }

        return "";
    }

    public getClassDemi(conges: CongeDto[], period: string): string {
        if (!this.enableAction) {
            return "no-action";
        }

        const getConge = this.getCongeInConges(conges, period);
        if (((getConge.Etat == EtatAbsencesEnum.Calcule && !this.canEditEvenIfCalcule) || getConge.Etat == EtatAbsencesEnum.Cloture)
            && (getConge.TypeConges == undefined || this.listeCodesAbsencesCrpcen.filter(c => c == getConge.TypeConges.Code).length == 0)) {
            return "info";
        }

        let returnClass = "click";

        if (!this.estValideOuPlus(getConge.Etat)) {
            returnClass += " wait ";
        }

        if (getConge.IsHover) {
            returnClass += " hover ";
        }

        if (getConge.IsFocus) {
            returnClass += " focus ";
        }

        return returnClass;
    }

    private removeFocusCell(): void {
        this.listTypeAbsence.filter(
            typeAbsence => typeAbsence.Salariees.filter(
                salarie => salarie.JoursDuMois.filter(
                    jour => jour.Conges.filter(
                        conge => conge.IsFocus = false)
                )));
    }

    public getColorInner(salarie: Salariee, conges: CongeDto[], period: string): BackgroundStyle {
        const conge = this.getCongeInConges(conges, period);

        let style: BackgroundStyle = {
            backgroundImage: undefined,
            backgroundColor: undefined
        };

        if (this.haveDetailsOnAbsence(salarie.Id, conge.TypeConges.Code)) {
            if (!this.estValideOuPlus(conge.Etat)) {
                style.backgroundImage = "linear-gradient(45deg, " + conge.TypeConges.Couleur + " 25%, #FFF 25%, #FFF 50%, " + conge.TypeConges.Couleur + " 50%, " + conge.TypeConges.Couleur + " 75%, #FFF 75%, #FFF)";
            } else {
                style.backgroundColor = conge.TypeConges.Couleur!;
            }
        } else {
            if (!this.estValideOuPlus(conge.Etat)) {
                style.backgroundImage = "linear-gradient(45deg, #3498db 25%, #FFF 25%, #FFF 50%, #3498db 50%, #3498db 75%, #FFF 75%, #FFF)";
            } else {
                style.backgroundColor = "#3498db";
            }
        }

        return style;
    }

    public getStyleLegendColor(color: string): any {
        return { backgroundColor: color };
    }

    public getColorCell(salarie: Salariee, conges: CongeDto[], period: string): any {
        const conge: CongeDto = this.getCongeInConges(conges, period);

        let codeCouleur = "";

        if (this.haveDetailsOnAbsence(salarie.Id, conge.TypeConges.Code)) {
            codeCouleur = conge.TypeConges.Couleur!;
        } else {
            codeCouleur = "#3498db";
        }

        return codeCouleur;
    }

    public isCongeEnAnnulation(conges: CongeDto[], period: string): any {
        const etat = this.getCongeInConges(conges, period).Etat;

        return etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire
            || etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1
            || etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2;
    }

    public addAbsence(idSalarie: number, idContrat: number): void {
        this.closeTooltip();
        this.$emit("addAbsence", idSalarie, null, idContrat, this.currentDate);
    }

    public addAbsenceCollective(): void {
        this.$emit("addAbsenceImposee", this.currentDate);
    }

    public deleteAbsenceCollective(): void {
        this.$emit("deleteAbsenceImposee");
    }

    public openTooltip(salarie: Salariee, conges: CongeDto[], period: string, event: MouseEvent): void {
        if (!this.enableAction) {
            return;
        }

        // Vérifie que le congé est dans un état permettant l'affichage de la tooltip (ni calculé, ni clôturé, sauf CRPCEN)
        const selectedConge = this.getCongeInConges(conges, period);
        const estCalculeOuCloture = (selectedConge.Etat == EtatAbsencesEnum.Calcule && !this.canEditEvenIfCalcule) || selectedConge.Etat == EtatAbsencesEnum.Cloture;
        const estAbsenceCrpcen = this.listeCodesAbsencesCrpcen.some(c => c == selectedConge.TypeConges.Code);

        if (estCalculeOuCloture && !estAbsenceCrpcen) {
            return;
        }

        // Stocke les infos du congé sélectionné pour les actions de la tooltip (valider, modifier, annuler, etc.)
        this.tooltipInfo = {
            idSalarie: salarie.Id,
            idContrat: salarie.IdContrat,
            idConge: selectedConge.Id!,
            congeCode: selectedConge.TypeConges.Code!,
            etat: selectedConge.Etat
        };

        // Met en surbrillance toutes les cellules du congé sélectionné dans le planning
        for (const typeAbsence of this.listTypeAbsence) {
            for (const salarie of typeAbsence.Salariees) {
                for (const jour of salarie.JoursDuMois) {
                    for (const conge of jour.Conges) {
                        if (conge.Id === selectedConge.Id) {
                            conge.IsFocus = true;
                        }
                    }
                }
            }
        }

        // Calcule la position initiale de la tooltip relative au conteneur calendrier, centrée sur la cellule cliquée
        const calendrierRect = (this.$refs.calendrier as HTMLElement).getBoundingClientRect();

        // (clientX : position horizontale du clic, offsetX : distance entre le clic et le bord gauche de l'élément cliqué /2 : pour centrer la tooltip sur le clic)
        this.tooltipPosition.x = event.clientX - calendrierRect.left - (event.offsetX / 2);
        // (offsetY : distance entre le clic et le bord supérieur de l'élément cliqué /2 : pour centrer la tooltip sur le clic, clientY : position verticale du clic)
        this.tooltipPosition.y = event.clientY - calendrierRect.top - (event.offsetY / 2);
        this.tooltipVisible = true;

        // Après le rendu, mesure les dimensions réelles de la tooltip et clamp la position pour qu'elle reste dans le conteneur
        this.$nextTick(() => {
            const tooltipEl = this.$el.querySelector(".tooltip-conge") as HTMLElement;
            if (!tooltipEl) return;

            // Mesure les dimensions réelles de la tooltip
            const tooltipRect = tooltipEl.getBoundingClientRect();

            // Clamp la position de la tooltip pour qu'elle reste dans le conteneur
            this.tooltipPosition.x = Math.max(0, Math.min(this.tooltipPosition.x, calendrierRect.width - tooltipRect.width));
            this.tooltipPosition.y = Math.max(0, Math.min(this.tooltipPosition.y, calendrierRect.height - tooltipRect.height));
        });
    }

    private closeTooltip(): void {
        this.tooltipVisible = false;
        this.removeFocusCell();

        this.tooltipInfo = {
            idSalarie: 0,
            idContrat: 0,
            idConge: 0,
            congeCode: "",
            etat: EtatAbsencesEnum.EnAttenteValidationGestionnaire
        };
    }

    public tooltipValid(): void {
        this.dataChange = true;
        const commande: CommandeChangementEtatAbsenceDto = { IdAbsence: this.tooltipInfo.idConge, Action: ActionAbsencesEnum.ValiderAbsenceParGestionnaire, Etat: this.tooltipInfo.etat };
        ServicesFactoryInstance.AbsencesService.changerEtatAbsence(commande, false, () => {
            NotificationServiceInstance.SendSuccess("La validation du congé s'est correctement déroulée !");
            EventBus.$emit(EventConstants.UPDATE_CONGES);
            this.fetchData();
        }, () => {
            this.fetchData();
        });

        this.closeTooltip();
    }

    public tooltipValiderDemandeAnnulation(): void {
        this.dataChange = true;
        const commande: CommandeChangementEtatAbsenceDto = { IdAbsence: this.tooltipInfo.idConge, Action: ActionAbsencesEnum.AnnulerAbsenceParGestionnaire, Etat: this.tooltipInfo.etat };

        ServicesFactoryInstance.AbsencesService.changerEtatAbsence(commande, false, absences => {
            NotificationServiceInstance.SendSuccess(`L'annulation de "${absences[0].LibelleTypeAbsence}" a été validée et l'absence a été supprimée !`);
            EventBus.$emit(EventConstants.UPDATE_CONGES);
            this.fetchData();
        }, () => {
            this.fetchData();
        });

        this.closeTooltip();
    }

    public tooltipAnnulerDemandeAnnulation(): void {
        this.dataChange = true;
        const commande: CommandeChangementEtatAbsenceDto = { IdAbsence: this.tooltipInfo.idConge, Action: ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParGestionnaire, Etat: this.tooltipInfo.etat };
        ServicesFactoryInstance.AbsencesService.changerEtatAbsence(commande, false, absences => {
            NotificationServiceInstance.SendSuccess(`L'annulation de "${absences[0].LibelleTypeAbsence}" a été refusée et l'absence est de nouveau à l'état validé!`);
            EventBus.$emit(EventConstants.UPDATE_CONGES);
            this.fetchData();
        }, () => {
            this.fetchData();
        });

        this.closeTooltip();
    }

    public tooltipContinue(edit: boolean): void {
        if (this.tooltipInfo.etat == EtatAbsencesEnum.Calcule) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Attention, cette absence a déjà été prise en compte sur le bulletin en cours du salarié. Il sera nécessaire de re-calculer son bulletin. Souhaitez-vous vraiment continuer ?",
                yesText: "OUI",
                callBackYes: _ => {
                    edit ? this.tooltipUpdate() : this.tooltipDelete();
                },
                callBackNo: _ => {
                    this.closeTooltip();
                    return;
                }
            });

            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
        } else {
            edit ? this.tooltipUpdate() : this.tooltipDelete();
        }
    }

    public tooltipUpdate(): void {
        this.$emit("addAbsence", this.tooltipInfo.idSalarie, this.tooltipInfo.idConge, this.tooltipInfo.idContrat, this.currentDate);
        this.closeTooltip();
    }

    public tooltipDelete(): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment supprimer cette absence ?",
            isBooleanChoiceVisible: true,
            booleanChoiceText: "Notifier le salarié par e-mail",
            callBackYes: modal => {
                this.dataChange = true;
                const envoyerEMailSalarie: boolean = modal?.booleanChoiceValue ?? false;
                const commande: CommandeChangementEtatAbsenceDto = { IdAbsence: this.tooltipInfo.idConge, Action: ActionAbsencesEnum.AnnulerAbsenceParGestionnaire, Etat: this.tooltipInfo.etat };
                ServicesFactoryInstance.AbsencesService.changerEtatAbsence(commande, envoyerEMailSalarie, () => {
                    NotificationServiceInstance.SendSuccess("La suppression du congé s'est correctement déroulée !");
                    EventBus.$emit(EventConstants.UPDATE_CONGES);
                    this.fetchData();
                }, () => {
                    this.fetchData();
                });
                this.closeTooltip();
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public estPossibleModifierAbsence(): boolean {
        return this.estPossibleValiderAbsence() || this.tooltipInfo.etat == EtatAbsencesEnum.Valide || (this.tooltipInfo.etat == EtatAbsencesEnum.Calcule && this.canEditEvenIfCalcule);
    }

    public estPossibleValiderAbsence(): boolean {
        return this.tooltipInfo.etat == EtatAbsencesEnum.EnAttenteValidationGestionnaire ||
            this.tooltipInfo.etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 ||
            this.tooltipInfo.etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2;
    }

    public estPossibleSupprimerAbsence(): boolean {
        return this.estPossibleModifierAbsence();
    }

    public estPossibleValiderDemandeAnnulation(): boolean {
        return this.tooltipInfo.etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire ||
            this.tooltipInfo.etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 ||
            this.tooltipInfo.etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2;
    }

    public estPossibleAnnulerDemandeAnnulation(): boolean {
        return this.estPossibleValiderDemandeAnnulation();
    }

    public estPossibleGenererAttestationCrpcen(): boolean {
        if (this.tooltipInfo?.congeCode == undefined) {
            return false;
        }

        return (this.listeCodesAbsencesCrpcen.filter(c => c == this.tooltipInfo.congeCode).length == 1);
    }

    /**
     * Affiche ou non le bouton permettant d'ouvrir la modale d'attestation CRPCEN temps partiel thérapeutique
     * @returns
     */
    public get estPossibleGenererAttestationCrpcenTpt(): boolean {
        if (this.tooltipInfo?.congeCode == undefined) {
            return false;
        }

        return FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.AttestationCrpcenTpt)
            && this.listeCodesAbsencesCrpcenTpt.includes(this.tooltipInfo.congeCode);
    }

    public generationCRPCEN(): void {
        const idConge = this.tooltipInfo.idConge;

        if (idConge != undefined) {
            ServicesFactoryInstance.AbsencesService.getAbsence(idConge, (data) => {
                this.$emit("generationCRPCEN", data);
                this.closeTooltip();
            });
        }
    }

    /**
     * Ouvre une popup avec les informations pour l'attestation CRPCEN
     * Pour les absences temps partiel thérapeutique
     */
    public generationCrpcenTpt(): void {
        if (this.tooltipInfo.idConge != null && this.tooltipInfo.idConge !== 0) {
            this.idCongeCrpcenTpt = this.tooltipInfo.idConge;
            this.closeTooltip();
            this.modalAttestationCrpcenTptVisible = true;
        }
    }

    /**
     * Reset les informations liées à la modal d'attestation CRPCEN temps partiel thérapeutique
     */
    public modalAttestationCrpcenTptClosed(): void {
        this.modalAttestationCrpcenTptVisible = false;
        this.idCongeCrpcenTpt = 0;
    }

    public hideDisplayHead(): boolean {
        return (this.sortDisplaySelected !== TypeRegroupementEquipe.responsable && this.sortDisplaySelected !== TypeRegroupementEquipe.service);
    }

    public estValideOuPlus(etat: EtatAbsencesEnum): boolean {
        let estValideOuPlus = false;
        if (etat == EtatAbsencesEnum.Valide ||
            this.estCalculeOuPlus(etat)) {
            estValideOuPlus = true;
        }

        return estValideOuPlus;
    }

    public estCalculeOuPlus(etat: EtatAbsencesEnum): boolean {
        let estValideOuPlus = false;
        if (etat == EtatAbsencesEnum.Calcule || etat == EtatAbsencesEnum.Cloture) {
            estValideOuPlus = true;
        }

        return estValideOuPlus;
    }

    public initListSortDisplay() {
        this.listSortDisplay = [];
        if (this.typeCalendrier === TypeCalendrier.Accueil || this.typeCalendrier === TypeCalendrier.GestionDesAbsences) {
            this.listSortDisplay.push({ key: TypeRegroupementEquipe.responsable, value: "Par catégorie" });
        }
        this.listSortDisplay.push({ key: TypeRegroupementEquipe.service, value: "Par service" });
    }

    public getAbsenceDataTestID(salariee: Salariee, day: JourDuMois, period: string): string {
        const conge: CongeDto = this.getCongeInConges(day.Conges, period);

        return DataTestIDHelper.getAbsenceCellInPlanningDataTestID(salariee.FullName, conge.TypeConges.LibelleConges, day.Date, period);
    }

    public getAddAbsenceButtonDataTestID(fullName: string): string {
        return DataTestIDHelper.getAddAbsenceButtonDataTestID(fullName);
    }

    // Récupére l'initialisation des données
    private getDefaultData(): CongesSalarieDto {
        return {
            Id: 0,
            Type: "",
            Salariees: [],
            EstAffichagePlanningAnonymise: true
        };
    }

    // Permet de savoir si on peut afficher les détails d'une absence
    private haveDetailsOnAbsence(idSalarieAbsence: number, codeAbsence?: string): boolean {
        let haveDetails: boolean = codeAbsence === "JTELE";

        switch (this.typeCalendrier) {
            case TypeCalendrier.Accueil:
            case TypeCalendrier.GestionDesAbsences:
            case TypeCalendrier.EspaceValideurExterne:
                haveDetails = haveDetails || !this.getData.EstAffichagePlanningAnonymise;
                break;
            case TypeCalendrier.EspaceValideurSalarie:
            case TypeCalendrier.EspaceSalarie:
                haveDetails = haveDetails || idSalarieAbsence === this.idSalarie;
                break;
        }

        return haveDetails;
    }

    public isDatePickerVisible = false;
    public showDateSelector(): void {
        if (this.dataReady) {
            this.isDatePickerVisible = true;
        }
    }

    public selectedDate(newDate: Date): void {
        this.dataReady = false;

        this.currentDate.setFullYear(newDate.getFullYear(), newDate.getMonth());
        this.currentMonth = newDate.getMonth();
        this.currentYear = newDate.getFullYear();

        this.setNewDate();

        this.isDatePickerVisible = false;
    }

    private setNewDate(): void {
        this.dataChange = true;

        if (this.idTriggerChangementMois > 0) {
            clearTimeout(this.idTriggerChangementMois);
            this.idTriggerChangementMois = 0;
        }

        this.idTriggerChangementMois = setTimeout(() => {
            this.filterTypeConges = "";
            this.fetchData();
        }, 500);
    }
}



// WEBPACK FOOTER //
// ./src/components/calendrier/calendrier.ts